export enum AvatarSource {
    Unknown = 0,
    Google = 'Google',
    Microsoft = 'Microsoft',
    Gravatar = 'Gravatar'
}

export type AvatarURLAndSource = {
    url: string;
    source: AvatarSource;
};

export type UserEmailWithAvatar = {
    email: string;
    avatarUrl: string;
};
